const k = "blakfy_a11y_prefs", C = "blakfy_a11y_prefs", me = 365, m = "1.0.0", F = {
  READY: "blakfy:a11y:ready",
  CHANGE: "blakfy:a11y:change",
  OPEN: "blakfy:a11y:open",
  CLOSE: "blakfy:a11y:close"
}, a = {
  fontScale: 100,
  contrast: "normal",
  focusRing: !1,
  linkUnderline: !1,
  motion: "auto",
  dyslexiaFont: !1,
  readingMode: !1,
  lineHeight: "normal",
  letterSpacing: "normal",
  textAlign: "default",
  highlightHeadings: !1,
  saturation: "normal",
  cursorSize: "default",
  hideImages: !1
}, M = ["tr", "en", "de", "fr", "es", "it", "ar", "he", "ru"], he = ["ar", "he"], ge = {
  INITIALIZED: "INITIALIZED",
  OPENDYSLEXIC_CDN_MISSING: "OPENDYSLEXIC_CDN_MISSING",
  STORAGE_MIGRATED: "STORAGE_MIGRATED",
  STORAGE_PARSE_ERROR: "STORAGE_PARSE_ERROR",
  SSR_HYDRATION_MISMATCH: "SSR_HYDRATION_MISMATCH",
  HOST_CSS_IMPORTANT_CONFLICT: "HOST_CSS_IMPORTANT_CONFLICT",
  LOCALE_FETCH_FAILED: "LOCALE_FETCH_FAILED",
  CDN_VERSION_MISMATCH: "CDN_VERSION_MISMATCH",
  OS_PREFERS_REDUCED_MOTION: "OS_PREFERS_REDUCED_MOTION",
  OS_PREFERS_CONTRAST_MORE: "OS_PREFERS_CONTRAST_MORE",
  OS_PREFERS_COLOR_SCHEME_DARK: "OS_PREFERS_COLOR_SCHEME_DARK"
}, P = {
  locale: "en",
  theme: "auto",
  position: "bottom-left",
  font: "",
  debug: !1
};
function y(e) {
  return typeof e == "object" && e !== null && !Array.isArray(e);
}
function x(e) {
  return e === 100 || e === 110 || e === 125 ? e : a.fontScale;
}
function H(e) {
  return e === "normal" || e === "high" ? e : a.contrast;
}
function u(e, t) {
  return typeof e == "boolean" ? e : t;
}
function N(e) {
  return e === "auto" || e === "reduce" ? e : a.motion;
}
function $(e) {
  return e === "normal" || e === "medium" || e === "large" ? e : a.lineHeight;
}
function U(e) {
  return e === "normal" || e === "medium" || e === "large" ? e : a.letterSpacing;
}
function G(e) {
  return e === "default" || e === "left" || e === "center" || e === "right" ? e : a.textAlign;
}
function j(e) {
  return e === "normal" || e === "high" || e === "low" || e === "none" ? e : a.saturation;
}
function z(e) {
  return e === "default" || e === "large-dark" || e === "large-light" ? e : a.cursorSize;
}
function Y(e) {
  return typeof e == "string" && M.includes(e) ? e : "en";
}
function V(e) {
  return e === "light" || e === "dark" || e === "auto" ? e : "auto";
}
function K(e) {
  return e === "bottom-left" || e === "bottom-right" || e === "top-left" || e === "top-right" ? e : "bottom-left";
}
function g(e, t) {
  return typeof e == "string" ? e : t;
}
function I(e) {
  return y(e) ? {
    fontScale: x(e.fontScale),
    contrast: H(e.contrast),
    focusRing: u(e.focusRing, a.focusRing),
    linkUnderline: u(e.linkUnderline, a.linkUnderline),
    motion: N(e.motion),
    dyslexiaFont: u(e.dyslexiaFont, a.dyslexiaFont),
    readingMode: u(e.readingMode, a.readingMode),
    lineHeight: $(e.lineHeight),
    letterSpacing: U(e.letterSpacing),
    textAlign: G(e.textAlign),
    highlightHeadings: u(e.highlightHeadings, a.highlightHeadings),
    saturation: j(e.saturation),
    cursorSize: z(e.cursorSize),
    hideImages: u(e.hideImages, a.hideImages)
  } : { ...a };
}
function B(e) {
  if (!y(e)) return null;
  const t = I(e.prefs), n = g(e.version, m), o = g(e.timestamp, (/* @__PURE__ */ new Date()).toISOString()), i = g(e.locale, "en");
  return { prefs: t, version: n, timestamp: o, locale: i };
}
function pe(e) {
  return y(e) ? {
    locale: Y(e.locale),
    theme: V(e.theme),
    position: K(e.position),
    font: g(e.font, ""),
    debug: u(e.debug, !1)
  } : { ...P };
}
function q(e, t) {
  if (!(typeof window > "u"))
    try {
      const n = new CustomEvent(e, { detail: t });
      window.dispatchEvent(n);
    } catch {
    }
}
function ye(e, t) {
  if (typeof window > "u")
    return () => {
    };
  const n = (o) => {
    t(o.detail);
  };
  return window.addEventListener(e, n), () => {
    typeof window > "u" || window.removeEventListener(e, n);
  };
}
const _ = "blakfy-a11y-host";
function A(e, t) {
  const n = `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"><path d="M6 2L6 26L12 20L16 28L19 27L15 19L22 19Z" fill="${e}" stroke="${t}" stroke-width="1.5" stroke-linejoin="round"/></svg>`;
  return `url("data:image/svg+xml,${encodeURIComponent(n)}") 6 2`;
}
function J(e) {
  const t = [];
  if (e.fontScale !== 100 && t.push(`html { font-size: ${e.fontScale}% !important; }`), e.contrast === "high" && t.push(
    "html body, html body * { background-color: #000000 !important; color: #ffffff !important; border-color: #333333 !important; }",
    "html body a, html body a * { color: #ffff00 !important; }",
    "html body img { filter: invert(1) hue-rotate(180deg) !important; }"
  ), e.focusRing && t.push(
    "html *:focus, html *:focus-visible { outline: 4px solid #2563eb !important; outline-offset: 2px !important; }"
  ), e.linkUnderline && t.push("html a { text-decoration: underline !important; }"), e.motion === "reduce" && t.push(
    "html *, html *::before, html *::after { animation-duration: 0.001ms !important; animation-iteration-count: 1 !important; transition-duration: 0.001ms !important; scroll-behavior: auto !important; }"
  ), e.dyslexiaFont && t.push(
    "html * { font-family: 'OpenDyslexic', OpenDyslexic, Arial, sans-serif !important; }"
  ), e.readingMode && t.push(
    'html aside, html [role="complementary"] { display: none !important; }',
    'html [class*="sidebar"], html [id*="sidebar"] { display: none !important; }',
    'html [class*="banner"]:not(main *) { display: none !important; }'
  ), e.lineHeight === "medium" ? t.push("html p, html li, html dd, html dt, html span, html div { line-height: 1.8 !important; }") : e.lineHeight === "large" && t.push("html p, html li, html dd, html dt, html span, html div { line-height: 2.4 !important; }"), e.letterSpacing === "medium" ? t.push("html * { letter-spacing: 0.08em !important; }") : e.letterSpacing === "large" && t.push("html * { letter-spacing: 0.16em !important; }"), e.textAlign !== "default" && t.push(
    `html p, html li, html h1, html h2, html h3, html h4, html h5, html h6 { text-align: ${e.textAlign} !important; }`
  ), e.highlightHeadings && t.push(
    "html h1, html h2, html h3, html h4, html h5, html h6 { outline: 3px solid #2563eb !important; outline-offset: 3px !important; }"
  ), e.saturation === "none" ? (t.push("html { filter: grayscale(100%) !important; }"), t.push("blakfy-a11y-root { filter: none !important; }")) : e.saturation === "high" ? (t.push("html { filter: saturate(2) !important; }"), t.push("blakfy-a11y-root { filter: none !important; }")) : e.saturation === "low" && (t.push("html { filter: saturate(0.3) !important; }"), t.push("blakfy-a11y-root { filter: none !important; }")), e.cursorSize === "large-dark") {
    const n = A("black", "white");
    t.push(`html *, html *::before, html *::after { cursor: ${n}, default !important; }`);
  } else if (e.cursorSize === "large-light") {
    const n = A("white", "black");
    t.push(`html *, html *::before, html *::after { cursor: ${n}, default !important; }`);
  }
  return e.hideImages && t.push(
    'html img, html picture, html [role="img"]:not(svg):not([aria-label*="accessibility"]) { opacity: 0 !important; }',
    "html video { visibility: hidden !important; }"
  ), t.join(`
`);
}
function W(e) {
  if (typeof document > "u") return;
  let t = document.getElementById(_);
  t || (t = document.createElement("style"), t.id = _, t.setAttribute("data-blakfy", ""), (document.head || document.documentElement).appendChild(t)), t.textContent = J(e);
}
function X(e) {
  if (typeof document > "u") return;
  const t = document.documentElement;
  t && (t.setAttribute("data-a11y-fontscale", String(e.fontScale)), t.setAttribute("data-a11y-contrast", e.contrast), t.setAttribute("data-a11y-focus", e.focusRing ? "enhanced" : "default"), t.setAttribute("data-a11y-links", e.linkUnderline ? "underline" : "default"), t.setAttribute("data-a11y-motion", e.motion), t.setAttribute("data-a11y-dyslexia", String(e.dyslexiaFont)), t.setAttribute("data-a11y-reading", String(e.readingMode)), t.setAttribute("data-a11y-lineheight", e.lineHeight), t.setAttribute("data-a11y-letterspacing", e.letterSpacing), t.setAttribute("data-a11y-textalign", e.textAlign), t.setAttribute("data-a11y-headings", String(e.highlightHeadings)), t.setAttribute("data-a11y-saturation", e.saturation), t.setAttribute("data-a11y-cursor", e.cursorSize), t.setAttribute("data-a11y-hideimages", String(e.hideImages)), W(e));
}
function T() {
  if (typeof window > "u" || typeof window.matchMedia != "function")
    return { reducedMotion: !1, contrast: "normal", colorScheme: "no-preference" };
  let e = !1, t = "normal", n = "no-preference";
  try {
    e = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  } catch {
  }
  try {
    window.matchMedia("(prefers-contrast: more)").matches ? t = "more" : window.matchMedia("(prefers-contrast: less)").matches && (t = "less");
  } catch {
  }
  try {
    window.matchMedia("(prefers-color-scheme: dark)").matches ? n = "dark" : window.matchMedia("(prefers-color-scheme: light)").matches && (n = "light");
  } catch {
  }
  return { reducedMotion: e, contrast: t, colorScheme: n };
}
function Se() {
  if (typeof document > "u") return !1;
  const e = document.styleSheets;
  if (!e) return !1;
  for (let t = 0; t < e.length; t++) {
    const n = e[t];
    if (!n) continue;
    let o = null;
    try {
      o = n.cssRules ?? null;
    } catch {
      continue;
    }
    if (o)
      for (let i = 0; i < o.length; i++) {
        const r = o[i];
        if (!r || r.type !== 1) continue;
        const l = r, p = l.selectorText ?? "";
        if (!Z(p)) continue;
        const c = l.style;
        if (c && (c.getPropertyPriority("color") === "important" || c.getPropertyPriority("background-color") === "important" || c.getPropertyPriority("background") === "important"))
          return !0;
      }
  }
  return !1;
}
function Z(e) {
  const t = e.toLowerCase();
  return /(^|[\s,>+~])(body|a)([\s,:.\[#>+~]|$)/.test(t);
}
function be(e) {
  if (typeof window > "u" || typeof window.matchMedia != "function")
    return () => {
    };
  const t = [
    "(prefers-reduced-motion: reduce)",
    "(prefers-contrast: more)",
    "(prefers-contrast: less)",
    "(prefers-color-scheme: dark)",
    "(prefers-color-scheme: light)"
  ], n = [], o = () => {
    e(T());
  };
  for (const i of t)
    try {
      const r = window.matchMedia(i);
      typeof r.addEventListener == "function" ? r.addEventListener("change", o) : typeof r.addListener == "function" && r.addListener(o), n.push(r);
    } catch {
    }
  return () => {
    for (const i of n)
      try {
        typeof i.removeEventListener == "function" ? i.removeEventListener("change", o) : typeof i.removeListener == "function" && i.removeListener(
          o
        );
      } catch {
      }
  };
}
const S = "2.0.0-alpha.0", R = 50, Q = 10, s = {
  issues: [],
  startTime: typeof performance < "u" ? performance.now() : Date.now(),
  devPipeUrl: null,
  devPipeLastSent: []
};
function D() {
  try {
    if (typeof process < "u" && typeof process.env < "u" && process.env.NODE_ENV && process.env.NODE_ENV !== "production")
      return "verbose";
  } catch {
  }
  if (typeof window > "u" || typeof document > "u")
    return "silent";
  try {
    if (new URLSearchParams(window.location.search).get("a11y-debug") === "1") return "verbose";
  } catch {
  }
  try {
    const e = document.currentScript;
    if (e && e.dataset && e.dataset.debug === "true" || document.querySelector('script[data-debug="true"]')) return "verbose";
  } catch {
  }
  try {
    const e = window;
    if (e.__BLAKFY_A11Y__ && e.__BLAKFY_A11Y__.debug === !0) return "verbose";
  } catch {
  }
  return "silent";
}
function ee(e) {
  return e === "info" ? "✓" : e === "warn" ? "⚠" : "✗";
}
function L(e, t) {
  if (typeof console > "u") return;
  const n = `[blakfy-a11y v${S}] ${ee(e)} ${t}`;
  e === "error" && typeof console.error == "function" ? console.error(n) : e === "warn" && typeof console.warn == "function" ? console.warn(n) : typeof console.info == "function" ? console.info(n) : typeof console.log == "function" && console.log(n);
}
function O(e, t, n) {
  const o = s.devPipeUrl;
  if (!o || D() !== "verbose" || typeof fetch != "function") return;
  const i = Date.now();
  if (s.devPipeLastSent = s.devPipeLastSent.filter((r) => i - r < 1e3), !(s.devPipeLastSent.length >= Q)) {
    s.devPipeLastSent.push(i);
    try {
      const r = JSON.stringify({ level: e, code: t, msg: n, timestamp: new Date(i).toISOString() });
      fetch(o, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: r,
        keepalive: !0
      }).catch(() => {
      });
    } catch {
    }
  }
}
function d(e, t, n, o) {
  const i = D();
  if (e === "info") {
    i === "verbose" && (L("info", n), O("info", t, n));
    return;
  }
  L(e, n);
  const r = {
    level: e,
    code: t,
    timestamp: (/* @__PURE__ */ new Date()).toISOString(),
    msg: n,
    ...o ? { extra: o } : {}
  };
  s.issues.push(r), s.issues.length > R && s.issues.splice(0, s.issues.length - R), O(e, t, n);
}
function Ee() {
  return s.issues.slice();
}
function we(e) {
  s.devPipeUrl = e;
}
function _e() {
  s.issues = [], s.startTime = typeof performance < "u" ? performance.now() : Date.now(), s.devPipeUrl = null, s.devPipeLastSent = [];
}
function Ae(e) {
  const t = T();
  return {
    version: S,
    locale: e.config.locale,
    theme: e.config.theme,
    storage: {
      version: e.storage.version,
      migratedFrom: e.storage.migratedFrom,
      keysFound: [...e.storage.keysFound]
    },
    osPreferences: {
      reducedMotion: t.reducedMotion,
      contrast: t.contrast,
      colorScheme: t.colorScheme
    },
    performance: {
      mountTimeMs: e.performance.mountTimeMs,
      bundleSizeGz: e.performance.bundleSizeGz,
      timeToFirstClick: e.performance.timeToFirstClick
    },
    issues: s.issues.map((n) => ({
      level: n.level,
      code: n.code,
      timestamp: n.timestamp,
      msg: n.msg
    })),
    config: { ...e.config },
    timestamp: (/* @__PURE__ */ new Date()).toISOString()
  };
}
function Re() {
  return S;
}
function b() {
  return typeof window < "u";
}
function v() {
  return typeof document < "u";
}
function te(e, t, n) {
  if (!v()) return;
  const o = /* @__PURE__ */ new Date();
  o.setTime(o.getTime() + n * 864e5);
  const i = b() && window.location && window.location.protocol === "https:", r = [
    `${e}=${encodeURIComponent(t)}`,
    `expires=${o.toUTCString()}`,
    "path=/",
    "SameSite=Lax"
  ];
  i && r.push("Secure"), document.cookie = r.join(";");
}
function ne(e) {
  if (!v()) return null;
  const n = (document.cookie || "").match(new RegExp(`(^| )${e}=([^;]+)`));
  if (!n || typeof n[2] != "string") return null;
  try {
    return decodeURIComponent(n[2]);
  } catch {
    return null;
  }
}
function ie(e) {
  if (!b()) return null;
  try {
    return window.localStorage.getItem(e);
  } catch {
    return null;
  }
}
function oe(e, t) {
  if (b())
    try {
      window.localStorage.setItem(e, t);
    } catch {
    }
}
function re(e) {
  if (e == null) return null;
  try {
    return JSON.parse(e);
  } catch {
    return null;
  }
}
function ae(e) {
  return e.version === m ? { record: e, migrated: !1, migratedFrom: null } : { record: {
    prefs: { ...a, ...e.prefs },
    version: m,
    timestamp: (/* @__PURE__ */ new Date()).toISOString(),
    locale: e.locale || "en"
  }, migrated: !0, migratedFrom: e.version };
}
function E() {
  const e = [], t = ie(k);
  t != null && e.push("localStorage");
  const n = ne(C);
  n != null && e.push("cookie");
  let o = null, i = null;
  if (t != null ? (o = t, i = "localStorage") : n != null && (o = n, i = "cookie"), o == null)
    return { source: null, record: null, migrated: !1, migratedFrom: null, keysFound: e };
  const r = re(o);
  if (r == null)
    return d("error", "STORAGE_PARSE_ERROR", `Failed to parse stored preferences from ${i}`), { source: i, record: null, migrated: !1, migratedFrom: null, keysFound: e };
  const l = B(r);
  if (!l)
    return d(
      "error",
      "STORAGE_PARSE_ERROR",
      `Stored preferences in ${i} did not match schema`
    ), { source: i, record: null, migrated: !1, migratedFrom: null, keysFound: e };
  const { record: p, migrated: c, migratedFrom: w } = ae(l);
  return c && d(
    "info",
    "STORAGE_MIGRATED",
    `Storage migrated: ${w ?? "unknown"} → ${m}`
  ), { source: i, record: p, migrated: c, migratedFrom: w, keysFound: e };
}
function se(e) {
  const t = JSON.stringify(e);
  oe(k, t), te(C, t, 365);
}
function le() {
  const e = E();
  return e.record ? { ...a, ...e.record.prefs } : { ...a };
}
function Le() {
  return E().record;
}
function ce(e, t = "en") {
  const n = le(), o = I({ ...n, ...e }), i = {
    prefs: o,
    version: m,
    timestamp: (/* @__PURE__ */ new Date()).toISOString(),
    locale: t
  };
  return se(i), X(o), q(F.CHANGE, i), i;
}
function Oe(e = "en") {
  return ce({ ...a }, e);
}
function ke() {
  const e = E();
  return {
    version: e.record?.version ?? m,
    migratedFrom: e.migratedFrom,
    keysFound: e.keysFound
  };
}
const ue = {
  label: "Accessibility preferences"
}, de = {
  title: "Accessibility Preferences",
  description: "Adjust your viewing preferences.",
  reset: "Reset",
  close: "Close",
  disclaimer: "This panel provides personal preference controls; structural accessibility is built into the site itself.",
  theme: {
    label: "Display Theme",
    auto: "Auto",
    light: "Light",
    dark: "Dark"
  },
  branding: "Powered by Blakfy Studio",
  sections: {
    profiles: "Accessibility Profiles",
    text: "Text",
    vision: "Vision",
    navigation: "Navigation",
    motion: "Motion & Reading"
  },
  profiles: {
    epilepsy: {
      name: "Epilepsy Safe",
      description: "Reduces animations and desaturates colors"
    },
    vision: {
      name: "Visual Impairment",
      description: "High contrast and enlarged text"
    },
    cognitive: {
      name: "Cognitive",
      description: "Reduces distractions, aids readability"
    },
    adhd: {
      name: "ADHD Friendly",
      description: "Hides images, stops motion"
    },
    blindness: {
      name: "Screen Reader",
      description: "Optimised for assistive technology"
    }
  },
  preferences: {
    fontScale: {
      title: "Font Size",
      description: "Scales all text proportionally across the page. Ideal for small screens or users with low vision; changes apply instantly everywhere.",
      values: {
        100: "Normal",
        110: "Large",
        125: "Extra Large"
      }
    },
    lineHeight: {
      title: "Line Height",
      description: "Increases vertical spacing between lines of text, improving readability for users with dyslexia or cognitive disabilities.",
      values: {
        normal: "Normal",
        medium: "Medium",
        large: "Large"
      }
    },
    letterSpacing: {
      title: "Letter Spacing",
      description: "Adds extra space between characters to reduce crowding and improve text clarity.",
      values: {
        normal: "Normal",
        medium: "Medium",
        large: "Large"
      }
    },
    textAlign: {
      title: "Text Alignment",
      description: "Changes the alignment of body text and headings across the page.",
      values: {
        default: "Default",
        left: "Left",
        center: "Center",
        right: "Right"
      }
    },
    highlightHeadings: {
      title: "Highlight Headings",
      description: "Adds a visible blue outline around all headings to make page structure easier to navigate."
    },
    contrast: {
      title: "High Contrast",
      description: "Applies a black background with high-visibility yellow links meeting the WCAG AAA 7:1 contrast ratio. Designed for users with visual impairments or colour blindness."
    },
    saturation: {
      title: "Color Saturation",
      description: "Adjusts color intensity. Use Grayscale to remove all color — useful for color blindness or reducing visual distraction.",
      values: {
        normal: "Normal",
        high: "High",
        low: "Low",
        none: "Grayscale"
      }
    },
    focusRing: {
      title: "Enhanced Focus Ring",
      description: "Displays a bold 4px blue outline around the focused element during keyboard navigation. Essential for users who cannot use or prefer not to use a mouse."
    },
    linkUnderline: {
      title: "Underline Links",
      description: "Adds underlines to all hyperlinks on the page. Helps users who cannot distinguish links from regular text by colour alone."
    },
    cursorSize: {
      title: "Cursor Size",
      description: "Enlarges the mouse cursor for better screen visibility. Choose dark or light to suit your background.",
      values: {
        default: "Default",
        largeDark: "Large Dark",
        largeLight: "Large Light"
      }
    },
    motion: {
      title: "Reduce Motion",
      description: "Disables page animations, transitions and scroll effects. Recommended for users with vestibular disorders, epilepsy or motion sensitivity."
    },
    dyslexiaFont: {
      title: "Dyslexia-Friendly Font",
      description: "Applies the OpenDyslexic typeface, adding extra weight to letter bottoms to reduce confusion between similar characters (b/d, p/q) and improve readability.",
      note: "Some readers find this helpful; research has not established universal benefit."
    },
    readingMode: {
      title: "Reading Mode",
      description: "Hides sidebars, banners and distracting side content so you can focus on the main text. Ideal for long articles or visually busy pages."
    },
    hideImages: {
      title: "Hide Images",
      description: "Hides all images on the page, reducing visual distraction. Useful for users sensitive to visual stimuli or on slow connections."
    }
  }
}, f = {
  fab: ue,
  panel: de
}, h = /* @__PURE__ */ new Map();
h.set("en", f);
function fe(e) {
  if (!e || typeof e != "object") return !1;
  const t = e, n = t.fab, o = t.panel;
  return !(!n || typeof n.label != "string" || !o || typeof o.title != "string");
}
async function Ce(e, t) {
  const n = h.get(e);
  if (n) return n;
  if (typeof fetch != "function")
    return d("warn", "LOCALE_FETCH_FAILED", `fetch unavailable, using en fallback for ${e}`), f;
  const i = `${(t || "").replace(/\/$/, "")}/locales/${e}.json`;
  try {
    const r = await fetch(i);
    if (!r.ok)
      return d("warn", "LOCALE_FETCH_FAILED", `Locale fetch failed (${r.status}): ${i}`), f;
    const l = await r.json();
    return fe(l) ? (h.set(e, l), l) : (d("warn", "LOCALE_FETCH_FAILED", `Locale ${e} payload missing required fields`), f);
  } catch (r) {
    const l = r instanceof Error ? r.message : String(r);
    return d("warn", "LOCALE_FETCH_FAILED", `Locale fetch threw for ${e}: ${l}`), f;
  }
}
function Ie(e) {
  return h.get(e) ?? null;
}
function Te() {
  return f;
}
function De() {
  h.clear(), h.set("en", f);
}
export {
  me as COOKIE_DAYS,
  C as COOKIE_KEY,
  a as DEFAULT_PREFS,
  F as EVENT_NAMES,
  ge as ISSUE_CODES,
  M as LOCALE_CODES,
  he as RTL_LOCALES,
  k as STORAGE_KEY,
  m as STORAGE_VERSION,
  ke as _inspectStorage,
  _e as _resetDiagnostics,
  De as _resetLocaleCache,
  d as addIssue,
  X as applyPreferences,
  Se as detectHostCSSConflicts,
  T as detectOSPreferences,
  q as emit,
  Ie as getCachedLocale,
  Ae as getDiagnostics,
  Te as getEnglishLocale,
  Ee as getIssues,
  D as getMode,
  le as getPreferences,
  Le as getPreferencesRecord,
  Re as getVersion,
  Ce as loadLocale,
  ye as on,
  Oe as resetPreferences,
  pe as safeMergeOptions,
  I as safeMergePrefs,
  B as safeParseRecord,
  we as setDevPipe,
  ce as setPreferences,
  be as subscribeToOSChanges
};
//# sourceMappingURL=index.js.map
